module.exports = __webpack_public_path__ + "img/black38.c8ae6c30.png";